import { Dialogs } from 'analytics/events/dialog';
import { ErrorWithUi } from 'errors';

import { useStores } from 'mobx/hooks/useStores';

import { DialogActionButtonProps, MessageDialog } from 'components/UIkit/atoms/Dialog';

export const GeneralErrorPopup = () => {
  const { uiStore } = useStores();
  const { error, errorDescription, clearError, cancelAction } = uiStore;
  const errorTitle = error instanceof ErrorWithUi ? error.ui.title : error?.message;

  const closeButtonProps = { onClick: clearError, text: cancelAction?.actionText || 'OK' };
  const primaryActionProps: DialogActionButtonProps = uiStore.action
    ? {
        onClick: uiStore.action.actionCallback,
        text: uiStore.action.actionText
      }
    : closeButtonProps;
  const secondaryActionProps = uiStore.additionalAction
    ? {
        onClick: uiStore.additionalAction.actionCallback,
        text: uiStore.additionalAction.actionText
      }
    : uiStore.action
    ? closeButtonProps
    : null;
  const tertiaryActionProps =
    uiStore.action && uiStore.additionalAction ? closeButtonProps : undefined;

  return (
    <MessageDialog
      id={Dialogs.GeneralError}
      isOpen={!!error}
      title={errorTitle}
      handleClose={clearError}
      primaryActionProps={primaryActionProps}
      secondaryActionProps={secondaryActionProps}
      tertiaryActionProps={tertiaryActionProps}
    >
      {errorDescription?.map((str, index) => (
        <div key={index}>{str}</div>
      ))}
    </MessageDialog>
  );
};
